import React from "react";
import { Ban, CreditCard, Trash2, Undo2, Pencil } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatINR } from "@/lib/api";
import { PAY_STATUS_STYLE, STATUS_STYLE } from "@/pages/admin/purchases/purchaseHelpers";

export const PurchasesTable = ({ purchases, staff, onOpenDetail, onPay, onReturn, onEdit, onCancel, onDelete }) => (
  <Card className="overflow-hidden">
    <div className="overflow-x-auto">
      <Table data-testid="purchases-table">
        <TableHeader><TableRow className="bg-[#F4EBDD]">
          <TableHead>Purchase #</TableHead><TableHead>Date</TableHead><TableHead>Supplier</TableHead><TableHead>Items</TableHead>
          <TableHead className="text-right">Total</TableHead><TableHead className="text-right">Outstanding</TableHead>
          <TableHead>Payment</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Actions</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {purchases.map((p) => (
            <TableRow key={p.id} className="hover:bg-[#F7F0E6] cursor-pointer" onClick={() => onOpenDetail(p)}>
              <TableCell className="font-mono text-sm">{p.purchase_no}</TableCell>
              <TableCell className="text-sm">{p.purchase_date}</TableCell>
              <TableCell>{p.supplier_name}</TableCell>
              <TableCell className="text-sm">{p.items?.length || 0} item(s)</TableCell>
              <TableCell className="text-right font-mono">{formatINR(p.total)}</TableCell>
              <TableCell className="text-right font-mono">
                {p.outstanding_amount > 0 ? <span className="text-[#7A1F1F]">{formatINR(p.outstanding_amount)}</span> : formatINR(0)}
                {(p.gold_outstanding_fine_g || 0) > 0 && <div className="text-[10px] text-[#7A4B12]">+ {Number(p.gold_outstanding_fine_g).toFixed(3)} g fine</div>}
              </TableCell>
              <TableCell><Badge className={PAY_STATUS_STYLE[p.payment_status]}>{p.payment_status}</Badge></TableCell>
              <TableCell><Badge className={STATUS_STYLE[p.status] || ""}>{p.status}</Badge>{p.edited_at && <div className="text-[10px] text-muted-foreground mt-0.5">edited</div>}</TableCell>
              <TableCell className="text-right space-x-1" onClick={(e) => e.stopPropagation()}>
                {p.status !== "cancelled" && ((p.outstanding_amount || 0) > 0 || (p.gold_outstanding_fine_g || 0) > 0) && <Button data-testid="purchase-pay-button" size="sm" variant="ghost" className="gap-1" onClick={() => onPay(p)}><CreditCard className="h-3.5 w-3.5" /> Pay</Button>}
                {p.status !== "cancelled" && <Button data-testid="purchase-edit-button" size="sm" variant="ghost" className="gap-1" onClick={() => onEdit(p)}><Pencil className="h-3.5 w-3.5" /> Edit</Button>}
                {p.status !== "cancelled" && <Button data-testid="purchase-return-button" size="sm" variant="ghost" className="gap-1" onClick={() => onReturn(p)}><Undo2 className="h-3.5 w-3.5" /> Return</Button>}
                {p.status !== "cancelled" && p.amount_paid === 0 && <Button size="sm" variant="ghost" className="text-destructive hover:text-destructive gap-1" onClick={() => onCancel(p)}><Ban className="h-3.5 w-3.5" /></Button>}
                {staff?.is_manager && (
                  <Button data-testid="purchase-delete-button" size="sm" variant="ghost" className="gap-1 text-destructive hover:text-destructive" onClick={() => onDelete(p)}><Trash2 className="h-3.5 w-3.5" /></Button>
                )}
              </TableCell>
            </TableRow>
          ))}
          {purchases.length === 0 && <TableRow><TableCell colSpan={9} className="text-center py-10 text-muted-foreground">No purchases yet. Record your first purchase to get started.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  </Card>
);
